import { API_URL } from '../../../app-config/constants';
import { get, post } from '../request';

const ENTRY = `${API_URL}/objectives`;

export function cloneObjective(objectiveId, userIds) {
    return post(`${ENTRY}/${objectiveId}/clone`, { postData: userIds });
}

export function getActivities(objectiveId) {
    return get(`${ENTRY}/${objectiveId}/activities`);
}
